
import DrawPoint from './DrawPoint';
import DrawPolyline from './DrawPolyline';
import DrawPolygon from './DrawPolygon.js';
import DrawCircle from './DrawCircle.js';
import DrawRectangle from './DrawRectangle'
import DrawStraightArrow from './DrawStraightArrow'
import DrawAttackArrow from './DrawAttackArrow'
import DrawPincerArrow from './DrawPincerArrow'
import DrawBillboard from './DrawBillboard'
import DrawSector from './DrawSector'
import DrawSphere from './DrawSphere'
import DrawCone from './DrawCone'

import DrawPolyline3 from "../plot2.0/polyline/DrawPolyline"
import DrawPolygon3 from "../plot2.0/polygon/DrawPolygon"
import DrawRectangleP3 from "../plot2.0/rectangleP/DrawRectangleP"
import DrawRectangle3 from "../plot2.0/rectangle/DrawRectangle"
import DrawTriangle from "../plot2.0/triangle/DrawTriangle"
import DrawBezier from "../plot2.0/bezierSpline/DrawBezier"
import DrawCircle3 from "../plot2.0/circle/DrawCircle"
import DrawStraightArrow3 from "../plot2.0/straightArrow/DrawStraightArrow"
import DrawAttackArrow3 from "../plot2.0/attackArrow/DrawAttackArrow"
import DrawPincerArrow3 from "../plot2.0/pincerArrow/DrawPincerArrow"
import DrawEllipsoid3 from "../plot2.0/ellipsoid/DrawEllipsoid"
import DrawCone3 from "../plot2.0/cone/DrawCone"
import DrawGatheringPlace from "../plot2.0/gatheringPlace/DrawGatheringPlace"
import DrawSquadCombat from "../plot2.0/squadCombat/DrawSquadCombat"
import DrawWall from "../plot2.0/wall/DrawWall"
import DrawPolylineVolume from "../plot2.0/polylineVolume/DrawPolylineVolume"
import DrawAssaultDirection from "../plot2.0/assaultDirection/DrawAssaultDirection"
import DrawSquare from "../plot2.0/square/DrawSquare"
import DrawSector3 from "../plot2.0/sector/DrawSector"


import StyleUtil from "../utils/StyleUtil.js"
class PlotManage {
    constructor() {
        this.options = {
            canEdit: true,
            billboard: {
                canEdit: true,
                image: "data/img/marker/mark2.png",
            },
            polyline3: {
                canEdit: true,
                //callbackEdit: options.callbackEdit
            },
            bezier: {
                canEdit: true,
                //callbackEdit: options.callbackEdit
            },
            polygon2: {
                canEdit: true,
                hasHeight: false
            },
            polygon3: {
                canEdit: true,
                typeName: "面体",
                extType: "polygon_Nor3"
            },
            ellipse2: {
                canEdit: true,
                hasHeight: false
            },
            rectangle2: {
                canEdit: true,
                hasHeight: false
            },
            square2: {
                canEdit: true,
                hasHeight: false
            },
            triangle2: {
                canEdit: true,
                hasHeight: false
            },
            military: {
                canEdit: true,
                hasHeight: false,
                typeName: "军标",
                extType: "svgEdit_Nor"
            },
            rectangle3: {
                canEdit: true
            },
            ellipsoid3: {
                canEdit: true
            },
            cone3: {
                canEdit: true
            },
            wall3: {
                canEdit: true
            },
            polylineVolume3: {
                canEdit: true
            },
            square3: {
                canEdit: true,
                typeName: "立方体",
                extType: "polygon_Nor3"
            },
            sector3: {
                canEdit: true,
                typeName: "扇形",
                extType: "polygon_Nor3"
            },
            triangle3: {
                canEdit: true,
                typeName: "三棱柱",
                extType: "polygon_Nor3"
            },
            ellipse3: {
                canEdit: true,
                typeName: "圆柱",
                //extType: "polygon_Nor3"
            },
            straightArrow3: {
                canEdit: true,
                typeName: "直线箭头",
                extType: "polygon_Nor3"
            },
            attackArrow3: {
                canEdit: true,
                typeName: "攻击箭头",
                extType: "polygon_Nor3"
            },
            pincerArrow3: {
                canEdit: true,
                typeName: "钳击箭头",
                extType: "polygon_Nor3"
            },
            squadCombat: {
                canEdit: true,
                typeName: "分队战斗",
                extType: "polygon_Nor3"
            },
            assaultDirection3: {
                canEdit: true,
                typeName: "突击方向",
                extType: "polygon_Nor3"
            },
            gatheringPlace: {
                canEdit: true,
                typeName: "集结地",
                extType: "polygon_Nor3"
            },
        };
        this.DrawIns = {};
        this.init();
    }

    init() {
        //原始版本
        this.DrawIns['point'] = new DrawPoint(this.options);
        this.DrawIns['line'] = new DrawPolyline(this.options);
        this.DrawIns['polygon'] = new DrawPolygon(this.options);
        this.DrawIns['circle'] = new DrawCircle(this.options);
        this.DrawIns['rectangle'] = new DrawRectangle(this.options);
        this.DrawIns['StraightArrow'] = new DrawStraightArrow(this.options);
        this.DrawIns['AttackArrow'] = new DrawAttackArrow(this.options);
        this.DrawIns['PincerArrow'] = new DrawPincerArrow(this.options);
        this.DrawIns['billboard'] = new DrawBillboard(this.options.billboard);
        this.DrawIns['sector'] = new DrawSector(this.options);
        this.DrawIns['sphere'] = new DrawSphere(this.options);
        this.DrawIns['cone'] = new DrawCone(this.options);

        //2D
        this.DrawIns['polygon2'] = new DrawPolygon3(this.options.polygon2);
        this.DrawIns['ellipse2'] = new DrawCircle3(this.options.ellipse2);
        this.DrawIns['rectangle2'] = new DrawRectangle3(this.options.rectangle2);
        this.DrawIns['military'] = new DrawRectangle3(this.options.military);
        this.DrawIns['square2'] = new DrawSquare(this.options.square2);
        this.DrawIns['triangle2'] = new DrawTriangle(this.options.triangle2);


        //3D
        this.DrawIns['polyline3'] = new DrawPolyline3(this.options.polyline3);
        this.DrawIns['polygon3'] = new DrawPolygon3(this.options.polygon3);
        this.DrawIns['rectangleP3'] = new DrawRectangleP3(this.options.rectangleP3);
        this.DrawIns['rectangle3'] = new DrawRectangle3(this.options.rectangle3);
        this.DrawIns['triangle'] = new DrawTriangle(this.options.triangle3);
        this.DrawIns['bezier'] = new DrawBezier(this.options.bezier);
        this.DrawIns['ellipse3'] = new DrawCircle3(this.options.ellipse3);
        this.DrawIns['straightArrow3'] = new DrawStraightArrow3(this.options.straightArrow3);
        this.DrawIns['attackArrow3'] = new DrawAttackArrow3(this.options.attackArrow3);
        this.DrawIns['pincerArrow3'] = new DrawPincerArrow3(this.options.pincerArrow3);
        this.DrawIns['ellipsoid3'] = new DrawEllipsoid3(this.options.ellipsoid3);
        this.DrawIns['cone3'] = new DrawCone3(this.options.cone3);
        this.DrawIns['gatheringPlace'] = new DrawGatheringPlace(this.options.gatheringPlace);
        this.DrawIns['squadCombat'] = new DrawSquadCombat(this.options.squadCombat);
        this.DrawIns['wall3'] = new DrawWall(this.options.wall3);
        this.DrawIns['polylineVolume3'] = new DrawPolylineVolume(this.options.polylineVolume3);
        this.DrawIns['assaultDirection3'] = new DrawAssaultDirection(this.options.assaultDirection3);
        this.DrawIns['square3'] = new DrawSquare(this.options.square3);
        this.DrawIns['sector3'] = new DrawSector3(this.options.sector3);

    }

    //callbackEdit: options.callbackEdit
    bindCallbackEdit(callbackEdit) {
        for (const key in this.DrawIns) {
            var ins = this.DrawIns[key];
            ins.callbackEdit = callbackEdit;
            if (key == "point") {
                ins.callback = callbackEdit
            }
            if (key == "billboard") {
                ins.callback = callbackEdit
            }
        }
    }

    bindPlotFlag(flag) {
        for (const key in this.DrawIns) {
            var ins = this.DrawIns[key];
            ins.isPlotflag = flag;
        }
    }

    //开始
    start(type, style) {
        this.reset();
        switch (type) {
            case 'point':
                this.DrawIns[type].start();
                break;
            case 'line':
                this.DrawIns[type].start();
                break;
            case 'polygon':
                this.DrawIns[type].start();
                break;
            case 'circle':
                this.DrawIns[type].start();
                break;
            case 'rectangle':
                this.DrawIns[type].start();
                break;
            case 'StraightArrow':
                this.DrawIns[type].start();
                break;
            case 'AttackArrow':
                this.DrawIns[type].start();
                break;
            case 'PincerArrow':
                this.DrawIns[type].start();
                break;
            case 'billboard':
                this.DrawIns[type].start();
                break;
            case 'sector':
                this.DrawIns[type].start();
                break;
            case 'sphere':
                this.DrawIns[type].start();
                break;
            case 'cone':
                this.DrawIns[type].start();
                break;
            case 'polyline3':
                this.DrawIns[type].start();
                break;
            case 'polygon3':
                this.DrawIns[type].start();
                break;
            case 'rectangleP3':
                this.DrawIns[type].start();
                break;
            case 'rectangle3':
                this.DrawIns[type].start();
                break;
            case 'triangle':
                this.DrawIns[type].start();
                break;
            case 'bezier':
                this.DrawIns[type].start();
                break;
            case 'ellipse3':
                this.DrawIns[type].start();
                break;
            case 'straightArrow3':
                this.DrawIns[type].start();
                break;
            case 'attackArrow3':
                this.DrawIns[type].start();
                break;
            case 'pincerArrow3':
                this.DrawIns[type].start();
                break;
            case 'ellipsoid3':
                this.DrawIns[type].start();
                break;

            case 'cone3':
                this.DrawIns[type].start();
                break;

            case 'gatheringPlace':
                this.DrawIns[type].start();
                break;
            case 'squadCombat':
                this.DrawIns[type].start();
                break;
            case 'wall3':
                this.DrawIns[type].start();
                break;
            case 'polylineVolume3':
                this.DrawIns[type].start();
                break;
            case 'assaultDirection3':
                this.DrawIns[type].start();
                break;
            case 'square3':
                this.DrawIns[type].start();
                break;
            case 'sector3':
                this.DrawIns[type].start();
                break;
            case 'polygon2':
                this.DrawIns[type].start();
                break;
            case 'ellipse2':
                this.DrawIns[type].start();
                break;
            case 'rectangle2':
                this.DrawIns[type].start();
                break;
            case 'square2':
                this.DrawIns[type].start();
                break;
            case 'polylineVolume3':
                this.DrawIns[type].start();
                break;

            case 'military':
                this.DrawIns["military"].start({
                    style: style
                });
                break;
            default:
                break;
        }

    }

    load(type, data) {

        let entity;
        switch (type) {
            case '点':
                entity = this.DrawIns["point"].loadPlot(data);
                break;
            case '图标':
                entity = this.DrawIns["billboard"].loadPlot(data);
                break;
            case '线':
                entity = this.DrawIns["polyline3"].loadPlot(data);
                break;
            case '曲线':
                entity = this.DrawIns["bezier"].loadPlot(data);
                break;
            case '面':
                entity = this.DrawIns["polygon2"].loadPlot(data);
                break;
            case '圆':
                entity = this.DrawIns["ellipse2"].loadPlot(data);
                break;
            case '矩形':
                entity = this.DrawIns["rectangle2"].loadPlot(data);
                break;
            case '正方形':
                entity = this.DrawIns["square2"].loadPlot(data);
                break;
            case '三角形':
                entity = this.DrawIns["triangle2"].loadPlot(data);
                break;
            case '面体':
                entity = this.DrawIns["polygon3"].loadPlot(data);
                break;
            case '扇形':
                entity = this.DrawIns["sector3"].loadPlot(data);
                break;
            case '立方体':
                entity = this.DrawIns["square3"].loadPlot(data);
                break;
            case '三棱柱':
                entity = this.DrawIns["triangle"].loadPlot(data);
                break;
            case '圆柱':
                entity = this.DrawIns["ellipse3"].loadPlot(data);
                break;
            case '球体':
                entity = this.DrawIns["ellipsoid3"].loadPlot(data);
                break;
            case '圆锥':
                entity = this.DrawIns["cone3"].loadPlot(data);
                break;
            case '墙体':
                entity = this.DrawIns["wall3"].loadPlot(data);
                break;
            case '管道':
                entity = this.DrawIns["polylineVolume3"].loadPlot(data);
                break;
            case '直线箭头':
                entity = this.DrawIns["straightArrow3"].loadPlot(data);
                break;
            case '攻击箭头':
                entity = this.DrawIns["attackArrow3"].loadPlot(data);
                break;
            case '钳击箭头':
                entity = this.DrawIns["pincerArrow3"].loadPlot(data);
                break;
            case '分队战斗':
                entity = this.DrawIns["squadCombat"].loadPlot(data);
                break;
            case '突击方向':
                entity = this.DrawIns["assaultDirection3"].loadPlot(data);
                break;
            case '集结地':
                entity = this.DrawIns["gatheringPlace"].loadPlot(data);
                break;

            case '军标':
                entity = this.DrawIns["military"].loadPlot(data);
                break;

        }

        return entity;
    }


    append(type, entity, data) {
        switch (type) {
            case '点':
                entity = this.DrawIns["point"].loadDynamicGraph(entity, data);
                break;
            case '图标':
                entity = this.DrawIns["billboard"].loadDynamicGraph(entity, data);
                break;
            case '线':
                entity = this.DrawIns["polyline3"].loadDynamicGraph(entity, data);
                break;
            default:
                break;
        }
    }

    checkRow(data, selected) {

        let uuid = data.markId;
        var entity = viewer.entities.getById(uuid);

        //没有加载
        if (selected && !entity) {
            entity = this.load(data.extType, data)
        }

        entity.show = selected;

        if (!selected) {
            StyleUtil.hidePlot(entity);
        }

        return entity;
    }

    removeRow(data) {
        let uuid = data.markId;
        var entity = viewer.entities.getById(uuid);
        if (entity) {
            viewer.entities.remove(entity);
        }
    }

    zoomTo(data) {

        var entity = this.checkRow(data, true);
        viewer.zoomTo(entity);
    }


    //设置编辑状态
    enableEdit(enable) {
        for (const key in this.DrawIns) {
            var ins = this.DrawIns[key];
            ins.enableEdit && ins.enableEdit(enable);
        }
    }

    //设置编辑状态
    disableEdit(enable) {
        for (const key in this.DrawIns) {
            var ins = this.DrawIns[key];
            ins.disableEdit && ins.disableEdit(enable);
        }
    }

    deleteVectorPlot(uuid) {
        var entity = viewer.entities.getById(uuid);
        if (entity) {
            StyleUtil.deletePlot(entity);
        }
    }

    reset() {
        for (const key in this.DrawIns) {
            var ins = this.DrawIns[key];
            ins.reset();
        }
    }

    save() {
        for (const key in this.DrawIns) {
            var ins = this.DrawIns[key];
            ins.editHelp && ins.toJson();
        }
    }

    //清空
    clear() {
        for (const key in this.DrawIns) {
            var ins = this.DrawIns[key];
            ins.clear();
        }
    }
    onDbclick(callback) {
        this.handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
        this.handler.setInputAction((e) => {
            callback && callback(e);
        }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
    }
    removeDbclick() {
        if (this.handler) {
            this.handler.destroy();
            this.handler = null;
        }
    }
}

export default PlotManage;